import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "display-5 mt-4"
}
const _hoisted_2 = {
  key: 1,
  class: "row pt-4"
}
const _hoisted_3 = { class: "megamenu-section row-space markdown-compact" }
const _hoisted_4 = ["href", "title"]
const _hoisted_5 = ["href", "title"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 2,
  class: "d-flex flex-column"
}
const _hoisted_8 = ["href", "title", "onMouseout", "onMouseover"]
const _hoisted_9 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon")

  return ($options.length($props.pages) == 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString($options.translations.actions.NO_RESULTS), 1 /* TEXT */))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.pages, (page) => {
          return (_openBlock(), _createElementBlock("div", {
            key: page.id,
            class: "col col-6 col-lg-4",
            style: _normalizeStyle({ order: page.kind_sequence })
          }, [
            _createElementVNode("div", _hoisted_3, [
              ($data.selected[page.id] || page.img)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "megamenu-preview rounded",
                    "data-track-event": "menu_link",
                    "data-track-type": "menu",
                    href: page.url,
                    style: _normalizeStyle({
            'background-image':
              'url(' +
              ($data.selected[page.id] ? $data.selected[page.id].img : page.img) +
              ')',
          }),
                    title: page.unicode,
                    onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.close && _ctx.close(...args)))
                  }, null, 12 /* STYLE, PROPS */, _hoisted_4))
                : _createCommentVNode("v-if", true),
              _createElementVNode("a", {
                class: "h6",
                "data-track-event": "menu_link",
                "data-track-type": "menu",
                href: page.url,
                title: page.unicode,
                onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.close && _ctx.close(...args)))
              }, [
                (page.icon)
                  ? (_openBlock(), _createBlock(_component_icon, {
                      key: 0,
                      name: page.icon
                    }, null, 8 /* PROPS */, ["name"]))
                  : _createCommentVNode("v-if", true),
                _createTextVNode(" " + _toDisplayString(page.unicode), 1 /* TEXT */)
              ], 8 /* PROPS */, _hoisted_5),
              ($options.length(page.descendants) == 0)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 1,
                    class: "small markdown",
                    innerHTML: page.description
                  }, null, 8 /* PROPS */, _hoisted_6))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.truncate_links(page), (sub) => {
                      return (_openBlock(), _createElementBlock("a", {
                        key: sub.id,
                        class: "megamenu-link",
                        "data-track-event": "menu_link",
                        "data-track-type": "menu",
                        href: sub.url,
                        style: _normalizeStyle({ order: sub.kind_sequence }),
                        title: sub.unicode,
                        onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.close && _ctx.close(...args))),
                        onMouseout: () => $options.delete_property($data.selected, page.id),
                        onMouseover: () => $options.set_property($data.selected, page.id, sub)
                      }, _toDisplayString(sub.unicode), 45 /* TEXT, STYLE, PROPS, NEED_HYDRATION */, _hoisted_8))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])),
              ($options.length(page.descendants) > $props.expandSize)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 3,
                    class: "megamenu-expand",
                    href: "#",
                    onClick: _withModifiers($event => ($options.toggle_expanded(page.id)), ["prevent"])
                  }, _toDisplayString($options.is_expanded(page.id)
              ? $options.translations.actions.HIDE
              : $options.translations.actions.SHOW_ALL +
                " (" +
                $options.length(page.descendants) +
                ")"), 9 /* TEXT, PROPS */, _hoisted_9))
                : _createCommentVNode("v-if", true)
            ])
          ], 4 /* STYLE */))
        }), 128 /* KEYED_FRAGMENT */))
      ]))
}